import { CreateOrUpdateStatusIncident, StatusIncident, UptimeResponse } from '../models/statusIncident';
import ApiService from './apiService';

class StatusIncidentService extends ApiService {
  private static instance?: StatusIncidentService;

  private constructor() {
    super(true); // bypass auth for public endpoints
  }

  static getInstance() {
    if (!StatusIncidentService.instance) {
      StatusIncidentService.instance = new StatusIncidentService();
    }
    return StatusIncidentService.instance;
  }

  // Public endpoints (no auth required)
  getActiveIncidents(): Promise<StatusIncident[]> {
    return this.client.get('/status-incident/active').then((response) => response.data);
  }

  getIncidentHistory(count: number = 100): Promise<StatusIncident[]> {
    return this.client.get(`/status-incident/history?count=${count}`).then((response) => response.data);
  }

  getUptime(): Promise<UptimeResponse> {
    return this.client.get('/status-incident/uptime').then((response) => response.data);
  }

  // Admin endpoints (requires SuperAdmin auth)
  getAllIncidents(): Promise<StatusIncident[]> {
    return this.client.get('/status-incident').then((response) => response.data);
  }

  getIncident(id: number): Promise<StatusIncident> {
    return this.client.get(`/status-incident/${id}`).then((response) => response.data);
  }

  createIncident(incident: CreateOrUpdateStatusIncident): Promise<StatusIncident> {
    return this.client.post('/status-incident', incident).then((response) => response.data);
  }

  updateIncident(id: number, incident: CreateOrUpdateStatusIncident): Promise<StatusIncident> {
    return this.client.put(`/status-incident/${id}`, incident).then((response) => response.data);
  }

  deleteIncident(id: number): Promise<void> {
    return this.client.delete(`/status-incident/${id}`);
  }
}

export default StatusIncidentService;
